export default "__VITE_ASSET__38f69649__"